import lazyLoadView from '@utils/lazy-load-view';
import roles from '@constants/roles.js';
// import validarRol from '@utils/router-helper'

export default {
	// prefix: 'somepath/',
	childof: 'inicio-view',
	routes: [
		{
			path: 'inicio',
			name: 'inicio',
			title: 'Inicio',
			component: () => lazyLoadView(import('@views/inicio.vue'))
		},
		{
			path: 'catalogos',
			name: 'catalogos',
			title: 'Catálogos',
			meta: { ocupaRol: [roles.Administrador] },
			// beforeEnter: validarRol,
			component: () => lazyLoadView(import('@views/submenu.vue'))
		},
		{
			path: 'catalogos/aspirantes',
			name: 'aspirantes',
			title: 'Aspirantes',
			meta: { ocupaRol: [roles.Administrador] },
			// beforeEnter: validarRol,
			component: () =>
				lazyLoadView(import('@views/catalogos/aspirantes/aspirantes.vue'))
		},

		{
			path: 'catalogos/carreras',
			name: 'carreras',
			title: 'Carreras',
			meta: { ocupaRol: [roles.Administrador] },
			// beforeEnter: validarRol,
			component: () =>
				lazyLoadView(import('@views/catalogos/carreras/carreras.vue'))
		},

		{
			path: 'catalogos/personal',
			name: 'personal',
			title: 'Personal',
			meta: { ocupaRol: [roles.Administrador] },
			// beforeEnter: validarRol,
			component: () =>
				lazyLoadView(import('@views/catalogos/personal/personal.vue'))
		},
		{
			path: 'catalogos/personal/aspirantes/:clavePersonal',
			name: 'personalAspirantes',
			title: 'Personal Aspirantes',
			meta: { ocupaRol: [roles.Administrador, roles.Personal] },
			component: () =>
				lazyLoadView(import('@views/catalogos/personal/aspirantes.vue'))
		}
	]
};
